import { uniqBy } from "lodash";
import {
  isRoot,
  currentUserIsCompanyOwner,
  isDocumentManager,
  isLearningRequestManager,
  getCurrentUserId,
  getCurrentCompanyId
} from "@/plugins/roles";

export class MainList {
  isLoading: boolean = false;
  params: any = undefined;
  method: any = undefined;
  singleMethod: any = undefined;
  listItems: Array<any> = [];
  listCount: number = 0;
  dataLabel: string = "items";
  baseParams: any = undefined;
  singleResult: any = undefined;

  constructor() {}

  get isNeedOwnerId(): boolean {
    return (
      this.root ||
      this.companyOwner ||
      this.documentManager ||
      this.learningRequestManager
    );
  }

  get userId(): string {
    return getCurrentUserId();
  }

  get root(): boolean {
    return isRoot();
  }

  get companyOwner(): boolean {
    return currentUserIsCompanyOwner();
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  get documentManager(): boolean {
    return isDocumentManager();
  }

  get learningRequestManager(): boolean {
    return isLearningRequestManager();
  }

  get getList(): Array<any> {
    return this.listItems;
  }

  get count(): number {
    return this.listCount;
  }

  updateCompany() {
    if (this.params.companyId) {
      this.params.companyId = this.companyId;
      this.clearList();
      this.list();
    }
  }

  clearList() {
    this.params = this.baseParams;
    this.listItems = [];
  }

  single() {
    this.singleMethod().then((res: { data: any }) => {
      this.listItems = uniqBy([res.data, ...this.listItems], "id");
      this.singleResult = res.data;
    });
  }

  list() {
    this.isLoading = true;
    this.method(this.params)
      .then((res: { data: any }) => {
        this.listCount = res.data.count;
        this.listItems = uniqBy(
          [...this.listItems, ...res.data[this.dataLabel]],
          "id"
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  sort() {
    this.isLoading = true;
    this.method(this.params)
      .then((res: { data: any }) => {
        this.listCount = res.data.count;
        this.listItems = res.data[this.dataLabel];
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  scrollEnd() {
    if (this.listCount > this.listItems.length) {
      this.params.offset =
        this.params.offset !== undefined && this.params.limit
          ? this.params.offset + this.params.limit
          : 0;
      this.list();
    }
  }

  initValue() {
    this.single();
  }
}
